import { ArrowUpDown } from 'lucide-react'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import type { ExploreSort } from '../../catalogApi'
import { messages } from './messages'

interface Props {
  value: ExploreSort
  onChange: (sort: ExploreSort) => void
}

/** Сортировка Explore: по рейтингу, по дате изменения, по прохождениям. */
export const SortDropdown = ({ value, onChange }: Props) => {
  const m = useMessages(messages)
  const labels: Record<ExploreSort, string> = {
    popular: m.sortPopular,
    updated: m.sortUpdated,
    completions: m.sortCompletions,
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="text-muted-foreground">
          <ArrowUpDown className="mr-1.5 size-4" />
          {labels[value]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 [&>div>*+*]:mt-0.5">
        <DropdownMenuRadioGroup value={value} onValueChange={(v) => onChange(v as ExploreSort)}>
          {(Object.keys(labels) as ExploreSort[]).map((key) => (
            <DropdownMenuRadioItem key={key} value={key}>
              {labels[key]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
